import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getSystemChatPermission = createAsyncThunk(
  "chatPermission/getSystemChatPermission",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.getSystemChatPermission(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const chatPermissionSlice = createSlice({
  name: "chatPermission",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSystemChatPermission.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSystemChatPermission.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getSystemChatPermission.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const systemChatPermission = (state) => state.systemChatPermission.value;
export const systemChatPermissionLoader = (state) => state.systemChatPermission.loading;

export default chatPermissionSlice.reducer;
